import { render, staticRenderFns } from "./rec_faq.vue?vue&type=template&id=0e5c9f9e&scoped=true&"
import script from "./rec_faq.vue?vue&type=script&lang=js&"
export * from "./rec_faq.vue?vue&type=script&lang=js&"
import style0 from "./rec_faq.vue?vue&type=style&index=0&id=0e5c9f9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c9f9e",
  null
  
)

export default component.exports